import { render, staticRenderFns } from "./sub-product.vue?vue&type=template&id=6e03152a&scoped=true&"
import script from "./sub-product.vue?vue&type=script&lang=js&"
export * from "./sub-product.vue?vue&type=script&lang=js&"
import style0 from "./sub-product.vue?vue&type=style&index=0&id=6e03152a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e03152a",
  null
  
)

export default component.exports